import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getUserById, deleteUser } from "../../services/api";

const UserDelete = () => {
  const { id } = useParams(); // Obtener el ID del usuario de la URL
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getUserById(id); // Obtener los detalles del usuario
        setUserData(user); // Establecer los datos del usuario en el estado
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };
    fetchUser();
  }, [id]);

  const handleDelete = async () => {
    try {
      await deleteUser(id); // Eliminar al usuario
      navigate("/users"); // Redirigir a la lista de usuarios
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  if (!userData) return <p>Loading...</p>;

  return (
    <>
      <h2>Eliminar Usuario</h2>
      <p>¿Estás seguro de que deseas eliminar a {userData.nombre}?</p>
      <button onClick={handleDelete}>Sí, eliminar</button>
      <button onClick={() => navigate("/users")}>Cancelar</button>
    </>
  );
};

export default UserDelete;
